import Vue from 'vue'
import Router from 'vue-router'
import firebase from 'firebase/app'
import TermsOfUse from '@/components/TermsOfUse'
import PrivacyPolicy from '@/components/PrivacyPolicy'
// import StoreSidebar from '@/components/store/StoreSidebar'
// import StoreNavbar from '@/components/store/StoreNavbar'
// import Header from '@/components/store/Header'
import StoreCart from '@/components/store/StoreCart'
import StoreCategories from '@/components/store/StoreCategories'
import StoreOffers from '@/components/store/StoreOffers'
import StoreItems from '@/components/store/StoreItems'
import StoreProducts from '@/components/store/StoreProducts'
import StoreProductDetails from '@/components/store/StoreProductDetails'
import StoreHome from '@/components/store/StoreHome'
import StoreServices from '@/components/store/StoreServices'
import StoreContact from '@/components/store/StoreContact'
import StoreAbout from '@/components/store/StoreAbout'
// import PSResults from '@/components/store/PSResults'


import UserSignup from '@/components/user/UserSignup'
import Signin from '@/components/user/Signin'
import CheckEmail from '@/components/user/CheckEmail'
import MyAccount from '@/components/user/MyAccount'

import RegShop from '@/components/user/RegShop'
import AllProducts from '@/components/admin/AllProducts'
import Categories from '@/components/admin/Categories'
import Customers from '@/components/admin/Customers'
import EditCommonProduct from '@/components/admin/EditCommonProduct'
import EditMobiles from '@/components/admin/EditMobiles'
import EditVehicles from '@/components/admin/EditVehicles'
import Offers from '@/components/admin/Offers'
import AdminGallery from '@/components/admin/Gallery'
import Items from '@/components/admin/Items'
import AllOffers from '@/components/admin/AllOffers'
import AllItems from '@/components/admin/AllItems'
import Dashboard from '@/components/admin/Dashboard'
import Admin from '@/components/admin/Admin'
import Payment from '@/components/admin/Payment'
import Orders from '@/components/admin/Orders'
import MyShopin from '@/components/admin/MyShopin'
// import Sidebar from '@/components/admin/Sidebar'
import AdminHome from '@/components/admin/AdminHome'
import AdminAbout from '@/components/admin/AdminAbout'
import AdminContact from '@/components/admin/AdminContact'
import Mobiles from '@/components/admin/Mobiles'
import Vehicles from '@/components/admin/Vehicles'

import RegServices from '@/components/user/RegServices'
import Services from '@/components/admin-services/Services'
import Gallery from '@/components/admin-services/Gallery'
import AllServices from '@/components/admin-services/AllServices'


Vue.use(Router)

let router = new Router({
  routes: [
 
   
    // {
    //   path: '/termsofuse',
    //   name: 'termsofuse',
    //   component: TermsOfUse,
    //   meta: {
    //     title: 'Terms Of Use',
    //   }
    // },
    // {
    //   path: '/privacypolicy',
    //   name: 'privacypolicy',
    //   component: PrivacyPolicy,
    //   meta: {
    //     title: 'Privacy Policy',
    //   }
    // },
    {
      path: '/contact',
      name: 'storecontact',
      component: StoreContact,
      meta: {
        title: 'Store Contact',
      }
    },
    {
      path: '/about',
      name: 'storeabout',
      component: StoreAbout,
      meta: {
        title: 'Store About',
      }
    },
    {
      path: '/',
      name: 'storehome',
      component: StoreHome,
      meta: {
        title: 'Store Home',
      }
    },
    {
      path: '/cart',
      name: 'storecart',
      component: StoreCart,
      meta: {
        title: 'Store Cart',
      }
    },
    {
      path: '/categories',
      name: 'storecategories',
      component: StoreCategories,
      meta: {
        title: 'Store Categories',
      }
    },
    {
      path: '/offers',
      name: 'storeoffers',
      component: StoreOffers,
      meta: {
        title: 'Store Offers',
      }
    },
    {
      path: '/items',
      name: 'storeitems',
      component: StoreItems,
      meta: {
        title: 'Store Items',
      }
    },
    {
      path: '/categories/:property/:cat',
      name: 'storeproducts',
      component: StoreProducts,
      meta: {
        title: 'Store Products',
      }
    },
    {
      path: '/productdetails/:id',
      name: 'storeproductdetails',
      component: StoreProductDetails,
      meta: {
        title: 'Store Product Details',
      }
    },
    {
      path: '/usersignup',
      name: 'usersignup',
      component: UserSignup,
      meta: {
        requiresGuest: true,
        title: 'Sign up'
      }
    },
    {
      path: '/signin',
      name: 'signin',
      component:Signin,
      meta: {
        requiresGuest: true,
        title: 'Sign in'
      }
      
    },
    {
      path: '/myaccount',
      name: 'myaccount',
      component: MyAccount,
      meta: {
        requiresAuth: true,
        title: 'My Account',
      }
      
      
    },
    {
      path: '/registration',
      name: 'regshop',
      component: RegShop,
      meta: {
        title: 'Register Store'
      }
     
    },
    
    {
      path: '/verifyemail',
      name: 'checkemail',
      component: CheckEmail,
      meta: {
        
        title: 'Verify Your Email'
      }
     
    },
    {
      path: '/admin/',
      name: 'admin',
      component: Admin,
      // path: 'admin',
      // name: 'admin',
      // component: Sidebar,
      meta: {
        requiresAuth: true,
        title: 'Admin'
      },
      children: [
        // {
        //   path: 'sidebar',
        //   name: 'sidebar',
        //   component: Sidebar
        // },
        {
          path: 'dashboard',
          name: 'dashboard',
          component: Dashboard,
          meta: {
            requiresAuth: true,
            title: 'Admin Dashboard'
          },
        },
        {
          path: 'adminhome',
          name: 'adminhome',
          component: AdminHome,
          meta: {
            requiresAuth: true,
            title: 'Admin Home Page'
          },
        },
        {
          path: 'adminabout',
          name: 'adminabout',
          component: AdminAbout,
          meta: {
            requiresAuth: true,
            title: 'Admin About Page'
          },
        },
        {
          path: 'admincontact',
          name: 'admincontact',
          component: AdminContact,
          meta: {
            requiresAuth: true,
            title: 'Admin Contact Page'
          },
        },
        {
          path: 'categories/:cat/allProducts',
          name: 'allProducts',
          component: AllProducts,
          meta: {
            requiresAuth: true,
            title: 'Admin All Products'
          },
        },
        {
          path: 'offers',
          name: 'offers',
          component: Offers,
          meta: {
            requiresAuth: true,
            title: 'Admin Offers'
          }
        },
        {
          path: 'gallery',
          name: 'admingallery',
          component: AdminGallery,
          meta: {
            requiresAuth: true,
            title: 'Admin Gallery'
          }
        },
        {
          path: 'customers',
          name: 'customers',
          component: Customers,
          meta: {
            requiresAuth: true,
            title: 'Admin Customers'
          }
        },
        {
          path: 'offers/alloffers',
          name: 'alloffers',
          component: AllOffers,
          meta: {
            requiresAuth: true,
            title: 'Admin All Offers'
          }
        },
        {
          path: 'items',
          name: 'items',
          component: Items,
          meta: {
            requiresAuth: true,
            title: 'Admin Items'
          }
        },
        {
          path: 'items/allitems',
          name: 'allitems',
          component: AllItems,
          meta: {
            requiresAuth: true,
            title: 'Admin All Items'
          }
        },
        {
          path: 'orders',
          name: 'orders',
          component: Orders,
          meta: {
            requiresAuth: true,
            title: 'Admin Orders'
          }
        },
        {
          path: 'myshopin',
          name: 'myshopin',
          component: MyShopin,
          meta: {
            requiresAuth: true,
            title: 'MY SHOPiN'
          }
        },
        {
          path: 'categories/:cat/addproducts',
          name: 'categories',
          component: Categories,
          meta: {
            requiresAuth: true,
            title: 'Admin Categories'
          },
        },   
        {
          path: 'categories/computers&mobiles/:cat/addproducts',
          name: 'mobiles',
          component: Mobiles,
          meta: {
            requiresAuth: true,
            title: 'Admin Categories'
          },
        },   
        {
          path: 'categories/vehicles/:cat/addproducts',
          name: 'vehicles',
          component: Vehicles,
          meta: {
            requiresAuth: true,
            title: 'Admin Categories'
          },
        },   
        {
          path: 'categories/:cat/product/edit/:product_id',
          name: 'editcommonproduct',
          component: EditCommonProduct,
          meta: {
            requiresAuth: true,
            title: 'Admin  Edit Products'
          },
        },
        {
          path: 'categories/computers&mobiles/:cat/product/edit/:product_id',
          name: 'editmobiles',
          component: EditMobiles,
          meta: {
            requiresAuth: true,
            title: 'Admin  Edit Products'
          },
        },
        {
          path: 'categories/vehicles/:cat/product/edit/:product_id',
          name: 'editvehicles',
          component: EditVehicles,
          meta: {
            requiresAuth: true,
            title: 'Admin  Edit Products'
          },
        },
        {
          path: 'payment',
          name: 'payment',
          component: Payment,
          meta: {
            requiresAuth: true,
            title: 'Payment'
          }
        },
    
      ]
    },

    // {
    //   path: '/admin-services/',
    //   name: 'admin-services',
    //   component: AdminServices,
    //   // path: 'admin',
    //   // name: 'admin',
    //   // component: Sidebar,
    //   meta: {
    //     requiresAuth: true,
    //     title: 'Admin'
    //   },
    //   children: [
    //     // {
    //     //   path: 'sidebar',
    //     //   name: 'sidebar',
    //     //   component: Sidebar
    //     // },
    //     {
    //       path: 'dashboard',
    //       name: 'dashboard-services',
    //       component: DashboardServices,
    //       meta: {
    //         requiresAuth: true,
    //         title: 'Admin Dashboard'
    //       },
    //     },
    //     {
    //       path: 'adminhome',
    //       name: 'adminhome-services',
    //       component: AdminHomeServices,
    //       meta: {
    //         requiresAuth: true,
    //         title: 'Admin Home Page'
    //       },
    //     },
    //     {
    //       path: 'adminabout',
    //       name: 'adminabout-services',
    //       component: AdminAboutServices,
    //       meta: {
    //         requiresAuth: true,
    //         title: 'Admin About Page'
    //       },
    //     },
    //     {
    //       path: 'admincontact',
    //       name: 'admincontact-services',
    //       component: AdminContactServices,
    //       meta: {
    //         requiresAuth: true,
    //         title: 'Admin Contact Page'
    //       },
    //     },
    //     {
    //       path: 'services',
    //       name: 'services',
    //       component: Services,
    //       meta: {
    //         requiresAuth: true,
    //         title: 'Admin Services'
    //       }
    //     },
    //     {
    //       path: 'gallery',
    //       name: 'gallery',
    //       component: Gallery,
    //       meta: {
    //         requiresAuth: true,
    //         title: 'Admin Gallery'
    //       }
    //     },
    //     {
    //       path: 'services/allservices',
    //       name: 'allservices',
    //       component: AllServices,
    //       meta: {
    //         requiresAuth: true,
    //         title: 'Admin All Services'
    //       }
    //     },
       
    //     {
    //       path: 'myshopin',
    //       name: 'myshopin-services',
    //       component: MyShopinServices,
    //       meta: {
    //         requiresAuth: true,
    //         title: 'MY SHOPiN'
    //       }
    //     },
       
    //   ]
    // },
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title
    //check for requriedAuth
    if(to.matched.some(record => record.meta.requiresAuth)) {
      if(!firebase.auth().currentUser){
        //Go to Signin
        console.log('user not')
        next({
          path: '/signin',
          query: {
            redirect: to.fullPath
          }
        });
      } else if(firebase.auth().currentUser.displayName == 'shop owner' && firebase.auth().currentUser.emailVerified){
        //Proceed to route
        if( to.fullPath != '/myaccount'){
          console.log('user else', firebase.auth().currentUser.displayName)
          console.log('user owner')
          next();
        }
      }else if(firebase.auth().currentUser.displayName == null && firebase.auth().currentUser.emailVerified){
        //Proceed to route
        if(to.fullPath == '/myaccount'){
          console.log('user else', firebase.auth().currentUser.displayName)
          console.log('user owner')
          next();
        }
      }else if(firebase.auth().currentUser && !firebase.auth().currentUser.emailVerified){
        //Proceed to route
        console.log('user else', firebase.auth().currentUser.displayName)
        console.log('user else', firebase.auth().currentUser.emailVerified)
        console.log('user else', firebase.auth().currentUser)
        console.log('user owner')
        next({
          path: '/verifyemail',
          query: {
            redirect: to.fullPath
          }
        });
      } else {
        console.log('user else', firebase.auth().currentUser)
        console.log('user else', firebase.auth().currentUser.displayName)
        // next({
        //   path: '/myaccount',
        //   query: {
        //     redirect: to.fullPath
        //   }
        // });
      }
    } else if(to.matched.some(record => record.meta.requiresGuest)){
      if(firebase.auth().currentUser){
       if(firebase.auth().currentUser.displayName == 'shop owner' && firebase.auth().currentUser.emailVerified ){
          console.log('user owner')
          next({
            path: '/admin/dashboard',
            query: {
              redirect: to.fullPath
            }
          })
        }else if(firebase.auth().currentUser.displayName == 'shop owner' && !firebase.auth().currentUser.emailVerified){
          console.log('user else', firebase.auth().currentUser.emailVerified)
          next({
            path: '/verifyemail',
            query: {
              redirect: to.fullPath
            }
          });
        }else if(firebase.auth().currentUser.displayName == null && firebase.auth().currentUser.emailVerified){
          console.log('user else', firebase.auth().currentUser.emailVerified)
          next({
            path: '/myaccount',
            query: {
              redirect: to.fullPath
            }
          })
        }else if(firebase.auth().currentUser.displayName == null && !firebase.auth().currentUser.emailVerified){
          console.log('user else', firebase.auth().currentUser.emailVerified)
          next({
            path: '/verifyemail',
            query: {
              redirect: to.fullPath
            }
          });
        }
      } else{
        //Proceed to route
        console.log('user not guest')
        next();
      }
    } else {
      //Proceed to route
      console.log('user is')
      next() 
    }
});

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js